import * as tslib_1 from "tslib";
import { ApplicationRef, DoBootstrap, Injector } from '@angular/core';
import { environment } from "../environments/environment";
import { BdpkConfigService } from "./bdpk-common/services/bdpk-config.service";
import { DxEncryptionStrategyType } from "./dx-core/config/dx-encryptions-type";
import { AppMocksProvider } from "./app-mocks.provider";
import { DxAppRoutes } from "./dx-core/config/dx-app-routes";
import { DxModalsConfig } from "./dx-modals/config/dx-modals-config";
import * as moment from "moment";
import 'moment/locale/ru';
import momentDurationFormatSetup from "moment-duration-format";
import { MOMENT_DURATION_FORMAT_RU } from "./dx-core/utiles/dx-core-datetime-utils";
import { DxNciService } from "./dx-nci-core/services/dx-nci.service";
import { Router } from "@angular/router";
import { DxSessionService } from "./dx-auth/services/dx-session.service";
/**
 *  Фабричная функция для предоставления конфига приложения.
 *  используется как механизм загрузки настроект приложения перед его страпом.
 *  То есть, согласно логике работы APP_INITIALIZER, ее вызов блокирует загрузку приложения,
 *  до окончания выполнения тела функции.
 */
export function provideAppConfig(configProvider, nciService, sessionService) {
    return () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        try {
            sessionService.currentSession = yield sessionService.storage.extract().toPromise();
        }
        catch (e) {
            // do nothing
        }
        // await nciService.fetchDictionaries(['type-file', 'plan-types']).toPromise();
        return configProvider.loadAppConfig();
    });
}
/** Фабричная функция для предоставления базовой части URL */
export function provideBaseLocation(configProvider) {
    return configProvider.baseUrl;
}
/**
 * Моки должны поставлять при помощи статичных фабричных функций
 * К сожению для lazy-load модулей придется забивать напрямую JSON.
 * Проблема в следующем:
 * Для использования статик-метода нужен класс, а для этого нужно импортировать модуль.
 * То есть он не должен быть lazy-load.
 * Момент второй импортрование InMemoryWebAPI в других модулях приводит к созданию нескольких
 * инстансов и путанице (Также как с HttpClient). Нужно и долго дебажить и разбираться как все развести.
 * Дабы не захламлять файл app.module я бы сделал отдельный класс со статик методами, который бы создавал
 * все моки.
 */
export function provideApiMocks() {
    return AppMocksProvider.provideAppMocks();
}
/** Фабричная функция для предоставления настроек модальных окон. */
export function provideModalsConfig(configProvider) {
    return configProvider.bdpkModalsConfig;
}
const ɵ0 = {
    env: environment
}, ɵ1 = {
    env: environment,
    encryptionStrategyType: DxEncryptionStrategyType.BASIC,
    goBackRoute: DxAppRoutes.NAVIGATOR_ROUTE,
    errorRoute: DxAppRoutes.ERROR_ROUTE
};
/**
 * =====================================================================================================================
 *                                      !!!!!!!!!! АХТУНГ !!!!!!!!!!
 * =====================================================================================================================
 *
 * Основной принцип построения много-модульного приложения (в том числе с lazy-load модулями).
 *
 * Lazy-load модули имеют свой собственный инжектор, следовательно при загрузке каждого lazy-load модуля X
 * для ВСЕХ сервисов, импортированных транзитивно из модулей-зависимостей модуля X, будет создан новый инстас.
 *
 * Поэтому, все сервисы, которые должны быть system-wide или шарится между lazy-load модулями, должны быть вынесены
 * в отдельные shared-модули и имортироваться в рутовом модуля приложения. Тогда для создания инстансов этих сервисов
 * будет использован рутовый инжектор. Следовательно они будут везде в единственном экзепляре. Даже в lazy-load модулях.
 * И не нужно будет импортировать лишние модули в lazy-load модулях.
 *
 * Если модулю в целом используется уровне рута (Импортируется в рутовом модуле или в eager-модулях).
 * То выделять из него shared-часть не нужно. Просто импортируем его. Это работает, так как рутовый модуль
 * и eager-модули используют один и тотже инжектор.
 *
*        !!! ЭТО ОЧЕНЬ ВАЖДНЫЙ АРХИТЕКТУРНЫЙ НЮАНС И НУЖНО ЭТО УЧИТЫВАТЬ ПРИ ПРОЕКТИРОВАНИЕ ФУНКЦИОНАЛА МОДУЛЕЙ !!!
 *
 * =====================================================================================================================
 *
 *
 * Нюанс по использованию перехватчиков!
 * Тонкость состоит в том, что секция:
 *   ```
 *   {
 *     provide: HTTP_INTERCEPTORS,
 *     useClass: DxLoggingInterceptor,
 *     multi: true
 *   }
 *   ```
 * должна провайдится единожды в приложении. Даже упоминание ее сначала в `@NgModule` в секции `providers`, а
 * потом в секции `providers` внутри метода `forRoot(...)` приводит к созданию двух инстансов перехватчика!!
 * И, следовательно, к мультипликации `http`-запросов.
 *
 * С учетом того:
 * 1. Порядок применения перехватчиков обусловлен их порядком следования в секции `providers`
 * 2. Перехвачиков может быть много и из разных модулей
 *
 * оптимальная стратегия использования перехватчиков такова:
 * 1. Определяем нужные перехватчики в своих модулях (по-функциональности)
 * 2. Импортируем НУЖНЫЕ перехватчики только в РУТ-МОДУЛЕ в нужном порядке
 */
export class AppModule {
    constructor(appRef, injector, router) {
        this.appRef = appRef;
        this.injector = injector;
        this.router = router;
        AppModule.injector = injector;
        const superShouldReuseRoute = this.router.routeReuseStrategy.shouldReuseRoute;
        this.router.routeReuseStrategy.shouldReuseRoute = (future, curr) => {
            return (future.url.length === 0 || future.queryParams.hash) ? false : superShouldReuseRoute(future, curr);
        };
        // setup Moment's locale
        moment.locale('ru');
        momentDurationFormatSetup(moment);
        moment.updateLocale('ru', MOMENT_DURATION_FORMAT_RU);
    }
    ngDoBootstrap(appRef) {
    }
}
export { ɵ0, ɵ1 };
